<div class="card affiliate-helper">
    <div class="content-header">{{ messages.Header }}</div>
    <div class="form-group">
        <div class="form-control-container" id="regularfield01">
            <input
                class="form-control form-control-sm ng-invalid focus"
                name="affiliate-source"
                type="text"
                [placeholder]="messages.Source"
                [(ngModel)]="source" />
        </div>
    </div>
    <div class="content-block d-flex flex-wrap">
        <div class="form-element col-6">
            <input class="custom-control-input custom-control-checkbox" id="affiliate-type" type="checkbox" [(ngModel)]="includeType" />
            <label for="affiliate-type">{{ messages.BetslipType }}</label>
        </div>
        <div class="form-element col-6">
            <input
                class="custom-control-input custom-control-checkbox"
                id="affiliate-stake"
                type="checkbox"
                (change)="toggle()"
                [(ngModel)]="includeStake" />
            <label for="affiliate-stake">{{ messages.Stake }}</label>
        </div>
        <div class="form-element col-6">
            <input
                class="custom-control-input custom-control-checkbox"
                id="affiliate-currency"
                type="checkbox"
                [disabled]="!includeStake"
                [(ngModel)]="includeCurrency" />
            <label for="affiliate-currency">{{ messages.Currency }}</label>
        </div>
        <div class="form-element col-6">
            <input class="custom-control-input custom-control-checkbox" id="affiliate-page" type="checkbox" [(ngModel)]="includePage" />
            <label for="affiliate-page">{{ messages.Page }}</label>
        </div>
    </div>
    <div class="content-block d-flex flex-wrap">
        <button class="primary-affiliate-button" ds-button kind="primary" variant="filled" size="medium" (click)="copy()">
            {{ messages.Copy }}
        </button>
        <button class="secondary-affiliate-button" ds-button kind="secondary" variant="filled" size="medium" (click)="clear()">
            {{ messages.Clear }}
        </button>
        <div class="content-message error theme-error-i">{{ messages.Warning }}</div>
    </div>
</div>
